<template>
    <div class="border rounded p-3 mb-3">
        <div class="fw-semibold mb-2">Per-Booking GPS Breakdown</div>
        <div class="table-responsive">
            <table class="table table-sm table-bordered mb-0 align-middle" style="font-size:0.82rem;">
                <thead class="table-light">
                    <tr>
                        <th style="width:16px;"></th>
                        <th>Client</th>
                        <th>Pick-up</th>
                        <th>Drop-off</th>
                        <th class="text-end">GPS pts</th>
                        <th class="text-end">GPS dist.</th>
                        <th class="text-end">Odo dist.</th>
                        <th class="text-end">Match</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in stats" :key="row.booking.uuid">
                        <td>
                            <span
                                style="display:inline-block; width:12px; height:12px; border-radius:50%;"
                                :style="{ background: bookingColor(row.i) }"
                            ></span>
                        </td>
                        <td>{{ row.booking.clientName ?? '—' }}</td>
                        <td>{{ formatTime(row.booking.actual_pick_up_time) }}</td>
                        <td>{{ formatTime(row.booking.actual_drop_off_time) }}</td>
                        <td class="text-end">
                            <span :class="row.points.length === 0 ? 'text-danger' : ''">{{ row.points.length }}</span>
                        </td>
                        <td class="text-end">{{ row.points.length > 0 ? row.gpsDistance.toFixed(2) + ' km' : '—' }}</td>
                        <td class="text-end">{{ row.odometerDistance !== null ? row.odometerDistance.toFixed(2) + ' km' : '—' }}</td>
                        <td class="text-end">
                            <span v-if="row.points.length === 0" class="badge bg-danger" title="No GPS data recorded for this booking">No GPS</span>
                            <span v-else-if="row.bookingAccuracyPct !== null" :class="`badge bg-${accuracyClass(row.bookingAccuracyPct)}`">{{ row.bookingAccuracyPct }}%</span>
                            <span v-else class="text-muted">—</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { bookingColor, accuracyClass, formatTime } from "../composables/useGpsAnalytics";
import type { BookingGpsStat } from "../composables/useGpsMapRendering";

defineProps<{ stats: BookingGpsStat[] }>();
</script>
